import {Button} from '@chakra-ui/react';
import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {getUserToken} from '../../helpers/localStorage';
import '../../styles/reports.css';

const Viewer = props => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = getUserToken();
    const authHeader = 'Bearer ' + token;
    const viewer = window.GrapeCity.ActiveReports.JSViewer.create({
      element: '#viewerContainer',
      parametersPanel: 'left',
      reportService: {
        url: 'https://api.gsareporting.com/api/reporting', // web service url
        // securityToken: 'security_token', //provide securityToken
        onRequest: init => {
          init.headers = {'Access-Control-Allow-Origin': 'https://api-gsareporting.plego.net', Authorization: authHeader};
          init.credentials = 'omit';
        },
      },
    });
    viewer.openReport(props.reportName, [props.reportParams]);
  });

  function GoBack() {
    navigate(-1);
  }
  return (
    <div>
      <Button onClick={GoBack} colorScheme="secondary">
        Back to Form
      </Button>
      <div id="viewerContainer" />
    </div>
  );
};

export default Viewer;
